import {ApiError, Checkout} from "@connox/typescript-library";
import React, {useState} from "react";
import Spinner from "../../utils/loader/Spinner";
import {Button, ButtonStyles, ButtonType} from "../form/Button/Button";
import {IPaymentModule, IPurchaseButtonProps, ISubmitPaymentResponse} from "./IPaymentModule";
import {INTERNAL_ERROR_TYPE, PaymentController, Payments} from "./PaymentController";
import window from "../WindowExtended";

export default class DefaultPaymentModule implements IPaymentModule {
  public readonly title = "Default Payment";

  constructor(readonly checkout: Checkout) {
    this.PurchaseButton = this.PurchaseButton.bind(this) as (props: IPurchaseButtonProps) => React.ReactElement;
  }

  public PurchaseButton(props: IPurchaseButtonProps): React.ReactElement {
    const [visible, setVisible] = useState<boolean>(true);
    const {handleError, label} = props;

    const actionMethod = async () => {
      setVisible(false);
      try {
        if (window.annotationTextArea !== (this.checkout.customerRemark ?? undefined)) {
          await this.checkout.put({customerRemark: window.annotationTextArea});
          await new Promise((resolve) => setTimeout(resolve, 400));
        }
        if (
          this.checkout.paymentId !== Payments.PaypalExpressBraintree &&
          this.checkout.paymentId !== Payments.AmazonPay
        ) {
          await PaymentController.initPayment();
        }
        await new Promise((resolve) => setTimeout(resolve, 400));
        await PaymentController.authorizePayment();
        await new Promise((resolve) => setTimeout(resolve, 400));
        await this.checkout.purchase();
      } catch (err) {
        const tempError = ((err as ApiError).originalError ?? err) as Error;
        tempError.name = INTERNAL_ERROR_TYPE.DEFAULT.OnCatch + tempError.name;
        setVisible(true);
        handleError(tempError, "default purchase");
      }
    };

    const spinner = React.createElement(Spinner, {}, null);

    return React.createElement(
      Button,
      {action: actionMethod, styles: [ButtonStyles.wide], type: visible ? ButtonType.default : ButtonType.disabled},
      visible ? label : spinner,
    );
  }

  public async onSubmitPayment(): Promise<ISubmitPaymentResponse> {
    return Promise.resolve({success: true});
  }

  public async onEnterSummary(): Promise<void> {
    return Promise.resolve();
  }

  public async onPaymentSelect(): Promise<void> {
    return Promise.resolve();
  }

  public isDataComplete(): boolean {
    return true;
  }
}
